import { Injectable } from '@angular/core';
import { ForgotPasswordGear } from '../gears/index.js';

@Injectable({ providedIn: 'root' })
export class ForgotPasswordFacade {
  constructor(private forgotPasswordGear: ForgotPasswordGear) { }

  send(email: any) {
    return this.forgotPasswordGear.send(email);
  }


  verifyActiveEmail(token: string, userId: string) {
    return this.forgotPasswordGear.verifyActiveEmail(token, userId);
  }


  sendActiveEmail(email: any) {
    return this.forgotPasswordGear.sendActiveEmail(email);
  }

  check(token: any, userId: any) {
    return this.forgotPasswordGear.check(token, userId);
  }

  updateNewPassword(token: any, userId: any, password: any) {
    return this.forgotPasswordGear.updateNewPassword(token, userId, password);
  }
}
